import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';
import { numberFormat } from '../../common/format';
import vInput from '../../components/v-input.vue';
import vForm from '../../components/v-form.vue';
import signLog from '../../components/sign-log';


import { normal } from '../defaultSpacing';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-house-facts'
    },
    asyncData: mapAsyncData(asyncData),
    components: { vInput, vForm },
    data: function() {
        return {
            contactInfo: {
                email: ''
            },
            showContact: false,
            greenClass: 'green',
            redClass: 'red',
            title: '',
            contactBTText: '',
            tip: '',
            listingDetail: {},
            ...normal
        };
    },
    methods: {
        minusDateByDays(date1, date2) {
            return Math.abs(
                ((date1.getTime() - date2.getTime()) / (60 * 60 * 1000 * 24)) |
                    0
            );
        },
        handleContact($event, theme = 'classic') {
            if (!this.user) {
                signLog.register(
                    {
                        languageTextFn: {
                            registerTitle: _ =>
                                this.$t('md-house-facts.contactUsForSelling'),
                            submitRegister: _ =>
                                this.$t('md-house-facts.submit')
                        },
                        onsuccess: () => this.scrollToInfomation(),
                        role: '1',
                        allowClose: true
                    },
                    theme
                );
            } else {
                this.scrollToInfomation();
            }
        },
        scrollToInfomation() {
            let informationMd = this.$root.getModuleByName('md-form');
            if (informationMd) {
                informationMd.$el.scrollIntoView();
                const dis = -80;
                window.scrollBy(0, dis);
            }
        },
        formatNumber(num) {
            let targetNum = numberFormat(num, true, 0);
            if (targetNum.indexOf('M') > -1) {
                //  by M One decimal place for units
                targetNum = numberFormat(num, true, 1);
            }
            return this.currencySymbol + ' ' + targetNum;
        }
    },
    computed: {

        ...rootMapState(usePageStore, {
            "currencySymbol": store => store.currency.symbol
        }),

        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),

        ...mapState({
            "median": "median",
            "estPriceValue": "estPriceValue",
            "rental": "rental"
        }),
        
        
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        exist() {
            return this.facts.length > 0;
        },
        facts() {
            const results = [];
            const info = (this.listingDetail && this.listingDetail.info) || {};
            const soldMedianPrice = Number(this.median); //  Regional average selling price
            const rentPrice = this.rental; //  Rental Estimated Price

            const estimatePrice = Number(this.estPriceValue); //  sell valuation
            const price = Number(info.soldPrice); //  selling price
            const diff = price - soldMedianPrice; //  difference
            const soldDate = new Date(info.soldDate);
            const soldDays = info.soldDate
                ? this.minusDateByDays(new Date(), soldDate)
                : '-';
            const isYeareEough = info.soldDate && soldDays >= 366;
            if (soldMedianPrice) {
                const percent =
                    !soldMedianPrice || diff == 0
                        ? '-'
                        : Math.abs(((diff * 100) / price).toFixed(2));
                const item = {
                    expressText:
                        diff > 0
                            ? this.$t('md-house-facts.moreExpensiveThanNearby')
                            : diff == 0
                                ? this.$t(
                                    'md-house-facts.sameAsTheNearbyProperties'
                                )
                                : this.$t('md-house-facts.lessExpensiveThanNearby'),
                    numberClass:
                        diff > 0
                            ? this.greenClass
                            : diff == 0 || !soldMedianPrice || !price
                                ? ''
                                : this.redClass,
                    number: `${percent}`,
                    iconClass: this.iconIncrease
                };
                if (diff != 0) {
                    item.trend =
                        !soldMedianPrice || diff == 0
                            ? false
                            : diff > 0
                                ? 'icon-trend-up'
                                : 'icon-trend-down';
                }
                price && results.push(item);

                if (!isYeareEough && soldMedianPrice) {
                    results.push({
                        expressText: this.$t('md-house-facts.medianPrice', {
                            zipCode: info.subDivisionName
                                ? 'Neighborhood'
                                : info.zipCode
                        }),
                        numberClass: '',
                        number: this.formatNumber(soldMedianPrice) || '-',
                        iconClass: this.iconNeighborHood
                    });
                }
            }
            if (isYeareEough && rentPrice) {
                results.push({
                    expressText: this.$t('md-house-facts.estimatedRentalPrice'),
                    number:
                        !rentPrice || rentPrice == '0'
                            ? '-'
                            : this.formatNumber(rentPrice),
                    numberClass: '',
                    iconClass: this.iconForecast
                });
            }
            let isOnSaleDaysEmpty = [-1, 0, undefined, null].includes(
                info.onSaleDays
            );
            if (!isYeareEough && (!isOnSaleDaysEmpty || info.soldDate)) {
                let listDays = !isOnSaleDaysEmpty
                    ? info.onSaleDays
                    : this.minusDateByDays(soldDate, new Date(info.listDate));
                listDays != 0 &&
                    results.push({
                        expressText: this.$t(
                            'md-house-facts.daysOnMarketUntil'
                        ),
                        number: listDays,
                        numberClass: '',
                        iconClass: this.iconDays
                    });
            } else if (price && estimatePrice) {
                const value = estimatePrice - price;
                results.push({
                    expressText: this.$t('md-house-facts.sinceLastSold', {
                        year: info.soldDate ? soldDate.getFullYear() : ''
                    }),
                    number:
                        value > 0
                            ? '+ ' + this.formatNumber(Math.abs(value))
                            : value == 0
                                ? '0'
                                : '- ' + this.formatNumber(Math.abs(value)),
                    numberClass:
                        value > 0
                            ? this.greenClass
                            : value == 0
                                ? ''
                                : this.redClass,
                    iconClass: this.iconEstimate
                });
            }
            return results;
        },
        cmpTitle() {
            return this.$t('md-house-facts.factsAboutThisProperty');
        },
        cmpContactBTText() {
            return this.$t('md-house-facts.contactUsNow');
        },
        cmpTip() {
            return this.$t('md-house-facts.contactUsIfYouAre');
        }
    }
};
